import { Injectable } from 'angular-ts-decorators';

import { Domain } from './domain';
import type { IConfig } from './config';

/**
 * This service is used to interact with the FoxPro API. The traffic is sent via Spynl services
 */
@Injectable('legacyBase')
export class LegacyBase {
  constructor(
    private $http: ng.IHttpService,
    private $q: ng.IQService,
    private config: IConfig,
    private domain: Domain,
  ) {
    'ngInject';
  }

  /**
   * @param {string} functionName fp's function name
   * @param {object} query all values that are sent to foxpro
   * @param {object} options additional options to send to $http request
   * Calls fp's endpoint
   * @returns {httpPromise} resolve with fetched data
   */
  callApi(
    functionName: string,
    query: object,
    options?: { timeout: number },
  ): ng.IPromise<any> {
    const requestOptions = Object.assign(
      {
        // done on config level for v7; setting for v6
        withCredentials: true,
      },
      options,
    );
    return this.$http
      .post(
        '//' + this.domain.sibling(this.config.spynlServices) + '/legacy-api',
        {
          function: functionName,
          query,
        },
        requestOptions,
      )
      .then((response: any) => response.data.data);
  }
}
